import { Booking, Product } from "../types/booking";

type TagStyle = {
  margin: number;
  background: string;
  color: string;
  borderColor: string;
};

export const TRANSPORT_TYPE_AIR = 1;
export const TRANSPORT_TYPE_SEA = 2;

export const getBookingProducts = (booking: Booking): Product[] => {
  const products = booking.product_info;
  if (!products) return [];
  if (Array.isArray(products)) {
    return Array.isArray(products[0])
      ? (products as Product[][]).flat()
      : (products as Product[]);
  }
  return [];
};

export const getTransportTypeId = (booking: Booking): number | null =>
  booking.transport_type ?? null;

export const isAirFreight = (booking: Booking): boolean =>
  getTransportTypeId(booking) === TRANSPORT_TYPE_AIR;

export const isSeaFreight = (booking: Booking): boolean =>
  getTransportTypeId(booking) === TRANSPORT_TYPE_SEA;

export const getBookingTotalCbm = (booking: Booking): number =>
  getBookingProducts(booking).reduce((sum, p) => sum + (p.cbm || 0), 0);

export const getBookingTotalKg = (booking: Booking): number =>
  getBookingProducts(booking).reduce(
    (sum, p) => sum + (p.gross_weight || 0),
    0
  );

export const getBookingTypeLabel = (booking: Booking): string => {
  const info = Array.isArray(booking.booking_type_info)
    ? booking.booking_type_info[0]
    : booking.booking_type_info;
  return info?.name || "-";
};

const BOOKING_TYPE_TAG_STYLES: Record<
  string,
  { background: string; color: string; borderColor: string }
> = {
  LCL: { background: "#e6f4ff", color: "#0958d9", borderColor: "#91caff" },
  FCL: { background: "#f9f0ff", color: "#531dab", borderColor: "#d3adf7" },
};

export const getBookingTypeTagStyle = (label: string): TagStyle | undefined => {
  const key = label.trim().toUpperCase();
  const preset = BOOKING_TYPE_TAG_STYLES[key];
  if (!preset) return undefined;
  return { margin: 0, ...preset };
};

export const formatBookingVolumeColumn = (booking: Booking): string => {
  if (isAirFreight(booking)) {
    const kg = getBookingTotalKg(booking);
    return kg > 0 ? `${kg.toFixed(1)} kg` : "-";
  }
  if (isSeaFreight(booking)) {
    const cbm = getBookingTotalCbm(booking);
    return cbm > 0 ? `${cbm.toFixed(3)} CBM` : "-";
  }
  return "-";
};
